import { ApiNotification } from '@/data'
import { StoreActionMap } from '@/store/types'

export interface ApiNotificationsReducer {
  currentApiNotifications: ApiNotification[]
}

export const initialApiNotificationsReducerState: ApiNotificationsReducer = {
  currentApiNotifications: [],
}

export enum ApiNotificationsTypes {
  Restore = 'ApiNotifications/RESTORE',
  Add = 'ApiNotifications/ADD',
  AddMultiple = 'ApiNotifications/ADD_MULTIPLE',
  Remove = 'ApiNotifications/REMOVE',
  Cleanup = 'ApiNotifications/CLEAN',
}

type ApiNotificationsPayload = {
  [ApiNotificationsTypes.Restore]: ApiNotificationsReducer
  [ApiNotificationsTypes.Add]: ApiNotification
  [ApiNotificationsTypes.AddMultiple]: ApiNotification[]
  [ApiNotificationsTypes.Remove]: string | null
  [ApiNotificationsTypes.Cleanup]: null
}

export type ApiNotificationsActions =
  StoreActionMap<ApiNotificationsPayload>[keyof StoreActionMap<ApiNotificationsPayload>]

let newState: ApiNotificationsReducer

export const apiNotificationsReducer = (
  curState: ApiNotificationsReducer,
  action: ApiNotificationsActions,
): ApiNotificationsReducer => {
  switch (action.type) {
    case ApiNotificationsTypes.Restore:
      return {
        ...action.payload,
      }
    case ApiNotificationsTypes.Add: {
      const notification = action.payload
      if (notification.status === 'unread') {
        newState = { ...curState }
        newState.currentApiNotifications = [...curState.currentApiNotifications]
        newState.currentApiNotifications.push(notification)
      }
      break
    }
    case ApiNotificationsTypes.AddMultiple: {
      const notifications = (action.payload ?? []).filter((n) => n.status === 'unread')
      newState = { ...curState }
      newState.currentApiNotifications = [
        ...curState.currentApiNotifications,
        ...notifications?.filter(
          (n, index) => newState.currentApiNotifications.findIndex((stateN) => stateN.id === n.id) !== index,
        ),
      ]
      break
    }
    case ApiNotificationsTypes.Remove: {
      const id = action.payload
      newState = { ...curState }
      newState.currentApiNotifications = curState.currentApiNotifications.filter((it) => it.id !== id)
      break
    }
    case ApiNotificationsTypes.Cleanup:
      return initialApiNotificationsReducerState
    default:
      newState = curState
  }
  return newState
}
